export default {
  container: {
    flexDirection: 'column',
    display: `flex`,
    alignItems: 'center',
    textAlign: 'center',
  },
  flexContainer: {
    mt: [null, 0, null, null, 0],
    display: `flex`,
    gap: 8,
  },
  tabs: {
    textAlign: [`center`, `left`],
  },
  textButtonWrapper: {
    width: '100%',
  },
  listItemContainer: {
    flexDirection: [null, 'column', null, null, 'row'],
    alignItems: [null, 'start', null, null, 'center'],
    textAlign: 'left',
    flexWrap: `wrap`,
    gap: 6,
    mr: 'auto',
    ml: [null, 0, null, null, 'auto'],
    '& svg': {
      width: '24px',
      height: '28px',
    },
  },
  iconWrapper: {
    display: `inline-flex`,
    margin: 'auto',
    flexShrink: 0,
  },
  text: {
    alignSelf: `auto`,
  },
  buttonsWrapper: {
    width: [null, '100%', null, 'fit-content'],
    mr: [null, 0, 'auto'],
  },
};
